import { VenueLayout } from "./venue-layout";
import { VenueFacility } from "./venue-facilitiy";
import { VenueCharge } from "./venue-charge";
import { VenueType } from "./venue-type";

export class Venue {
  name: string;
  id: number;
  description: string
  capacity: number;
  isActive: boolean;
  venueTypeId: number;
  venueType: VenueType;
  buildingUnitId: number;
  buildingId: number;
  buildingLevelId: number;
  hostCompanyId: number;
  venueLayouts: VenueLayout[];
  facilityTypes: number[];
  venueCharges: VenueCharge[];
  venueFacilities: VenueFacility[];
  defaultVenueLayout: VenueLayout;
  venueTypeName: string;
  isActiveForBooking: boolean;
}



// WEBPACK FOOTER //
// ./src/app/core/models/venue.ts